import React, { useState, useEffect } from "react";
import EmployeeForm from "./EmployeeForm";
import UseTables from "./Employees2";
import { useHistory, Redirect } from "react-router-dom";
import PeopleIcon from "@material-ui/icons/People";
import axios from "axios";
const isISODate = require("is-iso-date");

export default function Employees(props) {
  const initialTitle = "User";
  const initialApiEndpoint = "/employee";
  const header = "Users";
  const history = useHistory();
  const extraColumns = [
    { name: "name", label: "Full Name", options: { filter: false } },
    // {
    //   name: "salaryPerDay",
    //   label: "Salary per Day",
    //   options: { filter: false },
    // },
    // { name: "allowance", label: "Allowance", options: { filter: false } },
    // { name: "bank", label: "Bank", options: { filter: false } },
    // { name: "branch", label: "Branch", options: { filter: false } },
    // { name: "bankAccNo", label: "Acc No", options: { filter: false } },
    { name: "NIC", label: "NIC", options: { filter: false } },
    { name: "phone", label: "Mobile", options: { filter: false } },
    { name: "address", label: "Address", options: { filter: false } },
    { name: "joinDate", label: "Join Date", options: { filter: false } },
    { name: "email", label: "Email", options: { filter: false } },
    {
      name: "role",
      label: "Role",
      options: {
        filter: false,
        filterType: "dropdown",
        display: "true",
        // filterList: [],
        filterOptions: {
          names: ["admin", "moderator"],
        },
      },
    },
  ];
  // const table = useTables(
  //   initialTitle,
  //   initialApiEndpoint,
  //   extraColumns,
  //   EmployeeForm
  // );
  return (
    <>
      <UseTables
        initialTitle={initialTitle}
        initialApiEndpoint={initialApiEndpoint}
        header={header}
        Icon={PeopleIcon}
        extraColumns={extraColumns}
        Form={EmployeeForm}
        districtFilter={false}
        cropTypeFilter={false}
        startDateFilter={false}
        endDateFilter={false}
        cropFilter={false}
      />
    </>
  );
}
